export const APP_NAME = 'Galaktika'

export const TOKEN_STAKING_ACC = 'gtokenstakin'
export const TOKEN_ACC = 'gtokentest11'
export const GAME_ACC = 'gtestmainacc'
export const SHOP_CLAIM = 'gshoptestacc'

export const COLLECTION_NAME = 'galaktikacol'
export const COLLECTION_AVATAR_NAME = 'galaktiktest'
export const TEST_COLLECTION_NAME = 'galaktiktest'

export const RARITIES = [
  'Titanium',
  'Meteorite',
  'Beskar',
  'Chromium',
  'Plasma',
  'Luminaya',
  'Unicorn',
]

export const NFT_INFO_ACC = 'gtestmainacc'
export const MISSION_TYPES = ['Mining', 'Exploration', 'Discovery']
export const CIVILISATION_LIST = [
  'Axolotl',
  'Purgamen',
  'Alliance',
  'Luminayan',
  'Razatech',
  'Galaktika',
]
export const STAKE_PRICES = [
  5000.0, 13591.4, 36945.23, 100427.48, 272990.02, 742063.3, 1000000.0,
]
export const CIVILISATION_ID = {
  Axolotl: 1,
  Purgamen: 2,
  Alliance: 3,
  Luminayan: 4,
  Razatech: 5,
  Galaktika: 6,
}

export const DIFICULT_RANGES = {
  easy: 47.2,
  medium: 63.7,
  hard: 74.8,
  veryHard: 83,
  // ultraHard: ,
}

export const FIRST_EPOCH_DATE = new Date('2023-03-15T00:00:00')

export const IPFS_URL = 'https://atomichub-ipfs.com/ipfs/'
